import * as React from 'react'
import { Breadcrumbs, Typography } from '@material-ui/core'
import { Link } from 'react-router-dom/cjs/react-router-dom'

export default function CustomBreadcrumbs({ items = [] }) {
    return (
        <div role="presentation">
            <Breadcrumbs aria-label="breadcrumb">
                {items.map((item, index) => {
                    const isLast = index === items.length - 1
                    return isLast ? (
                        <Typography key={item.label} sx={{ color: 'text.primary' }}>
                            {item.label}
                        </Typography>
                    ) : (
                        <Link key={item.label} underline="hover" color="inherit" to={item.link}>
                            {item.label}
                        </Link>
                    )
                })}
            </Breadcrumbs>
        </div>
    )
}
